import PropTypes from 'prop-types'
import React from 'react'
import cc from 'classcat'

import styles from './Alert.css'

function Alert({ message, type, onClose }) {
  const classNames = cc([
    styles.alert,
    {
      [styles.danger]: type === 'danger',
      [styles.info]: type === 'info',
    },
  ])

  return (
    <div className={classNames}>
      <button type="button" className={styles.close} data-dismiss="alert" onClick={() => onClose()}>
        <span>&times;</span>
      </button>
      <div>{message}</div>
    </div>
  )
}

Alert.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}
Alert.defaultProps = {
  onClose: () => {},
  type: 'info',
}

export default Alert
